import React, {useEffect, useState} from 'react';
import { Link } from "react-router-dom";
import { Nav } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSchool, faUserGraduate, faChalkboardTeacher } from '@fortawesome/free-solid-svg-icons'
import { Navbar } from 'react-bootstrap';
import AuthService from '../../services/Auth/AuthService';
import PasswordChecklist from "react-password-checklist"
import {useLocation} from "react-router-dom";

export default function Register({ setRegister }) {
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [email, setEmail] = useState();
  const [address, setAddress] = useState();
  const [phoneNumber, setPhoneNumber] = useState();
  const [password, setPassword] = useState('');
  const [alreadyRegistered, setAlreadyRegistered] = useState(false);
  const [passwordValid, setPasswordValid] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [registerSuccess, setRegisterSuccess] = useState(false);
  const [verifyStatus, setVerifyStatus] = useState();

  const search = useLocation().search;

  useEffect(() => {
    document.title = "Cool Kids English - Register"

    const incomingVerifyStatus = new URLSearchParams(search).get('verifyStatus');
    const verifyEmail = new URLSearchParams(search).get('verifyEmail');
    setEmail(verifyEmail);
    setVerifyStatus(incomingVerifyStatus);

    console.log('Verify Status is: ', verifyStatus);
  }, []);

  const handleSubmit = async e => {
    e.preventDefault();
    const errorFields = []
    if (!firstName) {
      errorFields.push('First Name');
    }
    if (!lastName) {
      errorFields.push('Last Name');
    }
    if (!email) {
      errorFields.push('Email');
    }
    if (!phoneNumber) {
      errorFields.push('Phone Number');
    }
    if (!password) {
      errorFields.push('Password');
    }

    if (errorFields.length) {
      setErrorMessage(`Please specify the following ${errorFields.length === 1 ? 'field' : 'fields'}: ${errorFields.join(', ')}`);
      return;
    }

    if (!passwordValid) {
      setErrorMessage('');
      return;
    }
    setErrorMessage('');
    //now submit
    alert('submit disabled');
    return;
    const response = await AuthService.register({ firstName, lastName, email, password, address, phoneNumber});
    if (response.status === 409) {
      setAlreadyRegistered(true)
    } else if (response.status === 200) {
      setRegisterSuccess(true);
    }
  }

  const goToLogin = () => {
    setRegister(false);
  }

  const renderBody = () => {
    if (registerSuccess) {
      return (
        <div>
          <div>Successfully Registered {email}.</div>
          <div>Please check your email inbox to complete registration.</div>
        </div>
      );
    } else {
      return (
        <div className="edit-form">
          <h4>Parent Registration</h4>
          <div>Bitte geben Sie ihre information ein:</div>
          <form id="loginForm" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email *</label>
              <input
                type="text"
                autoComplete="off"
                className="form-control"
                id="email"
                name="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label htmlFor="title">Vorname *</label>
              <input
                type="text"
                autoComplete="off"
                className="form-control"
                id="firstName"
                name="firstName"
                value={firstName}
                onChange={e => setFirstName(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label htmlFor="title">Nachname</label>
              <input
                type="text"
                autoComplete="off"
                className="form-control"
                id="lastName"
                name="lastName"
                value={lastName}
                onChange={e => setLastName(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="title">Adresse</label>
              <input
                type="text"
                autoComplete="off"
                className="form-control"
                id="address"
                name="address"
                value={address}
                onChange={e => setAddress(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="title">Telefonnummer *</label>
              <input
                type="text"
                autoComplete="off"
                className="form-control"
                id="phoneNumber"
                name="phoneNumber"
                value={phoneNumber}
                onChange={e => setPhoneNumber(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="title">Password *</label>
              <input
                type="password"
                autoComplete="off"
                className="form-control"
                id="password"
                name="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
              {
              password && <PasswordChecklist
                rules={["minLength","specialChar","number","capital"]}
                minLength={8}
                value={password}
                onChange={(isValid) => {
                  setPasswordValid(isValid);
                  setErrorMessage('');
                }
                }
              />
              }
            </div>

            {
              alreadyRegistered && (
              <div>
                {email} is already registered.  <a href="#" onClick={() => goToLogin()}>click here to Log in</a>
              </div>
              )
            }
            { errorMessage && <div style={{color: 'red'}}>{errorMessage}</div>}
            <div className="buttonRow">
              <button
                  type="submit"
                  className="btn btn-primary"
                >
                  Submit
              </button>
              <button
                  className="btn btn-secondary"
                  onClick={goToLogin}
                >
                  Cancel
                </button>
            </div>
          </form>
        </div>
      )
    }
  }
  return(
    <div className="App">
      <title>Cool Kids English Parent Portal - Registration</title>
      <Navbar bg="primary" variant="dark" expand="md">
        <Navbar.Brand href="#home"><img alt="logo" className="logo" src={require('../../images/logo.png').default}/></Navbar.Brand>
        <h1>Parent Portal Registration</h1>
      </Navbar>
      <div className="col-md-6" style={{margin: 'auto'}}>
        {renderBody()}
      </div>
    </div>
  )
}
